/**
 * The one inter-process event path: NOTIFY twin_change (migration 0015,
 * specs/c2-kontratlar.md 1.3, K4). The payload names a table, an id and an operation,
 * never content: the receiver reads the row again with its own role.
 */
import { z } from 'zod';
export const CHANGE_CHANNEL = 'twin_change';
export const CHANGE_TABLES = [
    'approvals',
    'executions',
    'runs',
    'run_steps',
    'handoffs',
    'agents',
    'system_state',
    'requests',
    'tasks',
    'notifications',
    'stage_runs',
    'unknown_questions',
    'quota',
    'ping',
    // 0.4.1: connection secrets entered in the panel and their server side tests.
    'connection_secrets',
    'connection_tests',
    // v0.1.8: Etsy Bağla flows (the worker exchanges the code when k = authorized).
    'oauth_flows',
    // v0.1.54: Gönderilecekler (the worker sends an approved e-mail reply when a row is queued).
    'reply_outbox',
    // 0121: the ekip kanalı chat (id = message_id, k = kind).
    'team_messages',
];
export const changeTableSchema = z.enum(CHANGE_TABLES);
/**
 * id per table: the primary key, except executions (approval_id), run_steps (run_id of
 * the parent run) and quota (agent_id, or the provider when the snapshot has no agent).
 * k is a small discriminator, never content: the new status for most tables (approvals:
 * status when it changed or on insert, else execution_status, else "verifier_<verdict>"
 * for a verifier verdict), seq for run_steps, kind for notifications, quota_window for
 * quota, nothing for system_state and unknown_questions; the slot for connection_secrets
 * and connection_tests (0.4.1; the id is the row id, never a value); kind for team_messages (0121).
 */
export const changeNoticeSchema = z.object({
    v: z.literal(1),
    t: changeTableSchema,
    op: z.enum(['I', 'U']),
    id: z.string().min(1).max(200),
    k: z.string().min(1).max(64).optional(),
});
/** Parses a NOTIFY payload; null for anything that is not a v1 change notice. */
export function parseChangeNotice(payload) {
    let value;
    try {
        value = JSON.parse(payload);
    }
    catch {
        return null;
    }
    const parsed = changeNoticeSchema.safeParse(value);
    return parsed.success ? parsed.data : null;
}
/** The API's listener health probe: NOTIFY twin_change with this payload every 10 s. */
export function pingNotice(bootId, n) {
    return { v: 1, t: 'ping', op: 'I', id: `${bootId}.${n}` };
}
/** The API writes a ping every 10 s and expects it back within 5 s. */
export const PING_INTERVAL_MS = 10_000;
export const PING_TIMEOUT_MS = 5000;
/** The listener counts as healthy while the last ping came back within 15 s. */
export const LISTENER_HEALTHY_WITHIN_MS = 15_000;
//# sourceMappingURL=notify.js.map